import { Component, input, Input, InputSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { SkeletonLoaderComponent } from "@shared/components/ui/skeleton-loader";

export type TIconButtonType = 'ghost' | 'outline' | 'default' | 'primary' | 'destructive' | 'link' | 'success' | 'info' | 'secondary';
@Component({
  selector: 'lib-icon-button',
  imports: [NgClass, SkeletonLoaderComponent],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.css',
})
export class IconButtonComponent {
  /** The type of the button
   * @default 'default'
   * */
  @Input()
  type: TIconButtonType = 'default';

  /** The state of the button
   * @default 'default'
   * */
  @Input()
  state: 'default' | 'disabled' = 'default';

  /** The screen of the button
   * @default 'default'
   * */
  @Input()
  screen: 'desktop' | 'mobile' = 'desktop';


  /** The size of the button
   * @default 'default'
   * */
  @Input()
  size: 'small' | 'default' = 'default';

  /** The icon of the button
   * This icon is based on the flat icon Interface lib
   * example: circle
   * @default ''
   * */
  @Input()
  icon?: string;

  /** The color of the icon
   * @default 'default'
   * */
  @Input()
  iconColor?: string;

  /** The style of the button
 * @default 'default'
 * */
  @Input()
  style: 'squared' | 'rounded' = 'squared';

  /** The type of the button
   * @default 'button'
   * */
  @Input()
  buttonType: 'button' | 'submit' = 'button';


  /**
 * The unique identifier of the button.
 * @default null
 */
  public readonly id: InputSignal<string> = input<string>();

  public readonly skeleton: InputSignal<boolean> = input<boolean>(false);

}
